export const mortgageServices = [
  {
    id: "first-home",
    icon: "🏡",
    title: "First Home Loan",
    short:
      "We take you from pre-approval through to settlement, one step at a time.",
    bullets: [
      "Pre-approval and budgeting support",
      "Access to multiple NZ lenders",
      "Help using KiwiSaver and First Home grants",
      "Loan structures built around your cash-flow"
    ]
  },
  {
    id: "investment",
    icon: "📈",
    title: "Property Investment",
    short:
      "Lending set up so you can keep adding to your portfolio.",
    bullets: [
      "Strategy sessions before you buy, not after",
      "Interest-only vs principal & interest comparisons",
      "Rental yield and equity release analysis",
      "Support with multiple property lenders"
    ]
  },
  {
    id: "business",
    icon: "🏢",
    title: "Business Loan",
    short:
      "Funding for growth, working capital, new equipment or commercial premises.",
    bullets: [
      "Funding for expansion and cash-flow",
      "Support across major banks and lenders",
      "Help getting your financials into shape first",
      "Flexible structures for self-employed clients"
    ]
  },
  {
    id: "restructure",
    icon: "🧩",
    title: "Loan Restructuring",
    short:
      "We look at what you have now and restructure it to cut interest and shorten the term.",
    bullets: [
      "A full review of your current lending",
      "Split loans & fixed / floating mix",
      "Debt consolidation options",
      "Side-by-side scenarios before you switch anything"
    ]
  },
  {
    id: "debt",
    icon: "🧮",
    title: "Debt Consolidation",
    short:
      "Roll personal loans, credit cards and hire purchases into one repayment.",
    bullets: [
      "Compare what you pay now against the new structure",
      "Reduce interest where possible",
      "Simplify to one regular payment",
      "A realistic date for being debt-free"
    ]
  },
  {
    id: "mortgage-insurance",
    icon: "🛡️",
    title: "Mortgage Protection & Insurance",
    short:
      "Cover for your income and your family if something goes wrong.",
    bullets: [
      "Life, trauma, income & mortgage protection",
      "Comparison across major NZ insurers",
      "Cover you can afford to keep paying for",
      "Help with the claim if it comes to that"
    ]
  }
];

export const insuranceTypes = [
  {
    title: "Life Insurance",
    description:
      "A lump sum for your family to clear debt, or to keep a business going, if you die."
  },
  {
    title: "Income Protection",
    description:
      "Replaces part of your income if illness or injury keeps you off work for a long stretch."
  },
  {
    title: "Trauma & Health Cover",
    description:
      "Money on diagnosis of a serious condition, so the bills are not what you think about while recovering."
  },
  {
    title: "Mortgage Protection",
    description:
      "Keeps the mortgage paid while you recover from illness, injury or job loss. What is covered depends on the policy."
  }
];

export const teamMembers = [
  {
    name: "Devon Sharma",
    role: "Director & Senior Mortgage Adviser",
    blurb:
      "Devon has more than 15 years’ experience in lending, working mostly with families on structure and longer-term planning."
  },
  {
    name: "Sushil Kaur",
    role: "Mortgage & Insurance Adviser",
    blurb:
      "Sushil works with first home buyers and investors, on both the lending and the protection side."
  },
  {
    name: "Expert Finance Team",
    role: "Support & Client Services",
    blurb:
      "Our client services team handles the paperwork and chases the lenders, so deadlines do not quietly slip."
  }
];
